import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import AIAssistant from '../common/AIAssistant';

interface MainLayoutProps {
  children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar />
      <div className="lg:pl-64">
        <Navbar />
        <main className="pt-16">
          <div className="px-4 py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
      <AIAssistant />
    </div>
  );
}
